// Shared date-of-birth helpers for the DD/MM/YYYY (or DD/MM/YY) text boxes.

// ISO (YYYY-MM-DD) from the API -> DD/MM/YYYY for display.
export const formatDob = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
};

// Types digits only and inserts the slashes: 260102 -> 26/01/02, 26012002 -> 26/01/2002.
export const maskDob = (value) => {
  const d = value.replace(/\D/g, "").slice(0, 8);
  if (d.length <= 2) return d;
  if (d.length <= 4) return `${d.slice(0, 2)}/${d.slice(2)}`;
  return `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}`;
};

// "" when empty, null when it is not a real past date, otherwise the text as typed.
// A two-digit year is 20YY unless that is in the future, then 19YY (same rule as the API).
export const checkDob = (text) => {
  if (!text) return "";
  const m = /^(\d{2})\/(\d{2})\/(\d{2}|\d{4})$/.exec(text);
  if (!m) return null;
  const [day, month] = [Number(m[1]), Number(m[2])];
  const now = new Date();
  let year = Number(m[3]);
  if (m[3].length === 2) {
    year += Math.floor(now.getFullYear() / 100) * 100;
    if (new Date(year, month - 1, day) > now) year -= 100;
  }
  const probe = new Date(year, month - 1, day);
  const real = probe.getFullYear() === year && probe.getMonth() === month - 1 && probe.getDate() === day;
  return real && year >= 1900 && probe <= now ? text : null;
};

export const DOB_ERROR = "Please enter the date of birth as DD/MM/YYYY or DD/MM/YY, for example 26/01/2002 or 26/01/02.";
